import * as globals from '@wandb/weave/common/css/globals.styles';
import {Icon} from '@wandb/weave/components/Icon';
import styled from 'styled-components';

export const HideRunSetsIcon: typeof Icon = styled(Icon)`
  font-size: 28px;
  padding: 2px 0 0 4px;
  color: ${globals.gray500};
  cursor: pointer;
  &:hover {
    color: darken(${globals.gray500}, 12%);
  }
`;
